import { PermissionDto } from 'api/Identity/Types/PermissionDto'
import { IntroducingBrokerDetailedProfileDto } from 'api/Trading-Accounts/Types/IntroducingBrokerDetailedProfileDto'

export enum IntroducingBrokerProfileTypes {
  DETAILS = 'details',
  ACCOUNT_GROUP = 'account-groups',
  IBS = 'ibs',
  INSTRUMENTS = 'instruments',
}

export const getIntroducingBrokerProfileType = (
  pageType: string
): IntroducingBrokerProfileTypes => {
  if (pageType === 'details') {
    return IntroducingBrokerProfileTypes.DETAILS
  }
  if (pageType === 'account-groups') {
    return IntroducingBrokerProfileTypes.ACCOUNT_GROUP
  }
  if (pageType === 'ibs') {
    return IntroducingBrokerProfileTypes.IBS
  }
  if (pageType === 'instruments') {
    return IntroducingBrokerProfileTypes.INSTRUMENTS
  }
  return IntroducingBrokerProfileTypes.DETAILS
}

export type MatchParams = {
  id: string
  slug: string
}

export type IntroducingBrokerProfileProps = {
  profile: IntroducingBrokerDetailedProfileDto
  permissions: PermissionDto[]
  forceRefresh: () => void
}

export interface AccountGroupNameDto {
  id: string
  name: string
}

export enum RebateCalculationMethod {
  PER_LOT = 1,
  PER_MILLION_USD = 2,
  PER_PERCENTAGE_0F_BASE_CURRENCY = 3,
  PER_SPREAD_SHARE = 4,
  POINT_BASED = 5,
}
